<template>
  <div class="fixed-position homeHeader">
    <div class="head-bar">
      <!-- 顶部栏 -->
      <div class="head-top">
        <div class="top-container">
          <div class="top-left">
            <img
              src="../../assets/images/postion.png"
              alt=""
              style="width: 10px; height: 13px"
            />
            <el-select
              v-model="regionBar"
              @change="change_province"
              placeholder="请选择"
              class="regionSelect"
            >
              <el-option
                v-for="item in regionBarOptions"
                :key="item.value"
                :label="item.label"
                v-if="item.label != regionBar"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 费用说明 -->
            <template>
              <el-select
                value=""
                placeholder="找我婚礼费用说明"
                class="regionSelect fee-select"
                popper-class="fee-select-popper"
              >
                <el-option value="找我婚礼婚礼人其他费用说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/doc/DRUJ6WU1hU1FBU3NJ"
                      target="_blank"
                      >找我婚礼婚礼人其他费用说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼费用结构说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRURyTEluUlpheU9v"
                      target="_blank"
                      >找我婚礼费用结构说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼布置费人员价格指导">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRVpJWU1qWW1KaG54"
                      target="_blank"
                      >找我婚礼布置费人员价格指导</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
                <el-option value="找我婚礼退单标准说明">
                  <div class="fee-select-item">
                    <a
                      href="https://docs.qq.com/sheet/DRWFXbXFqZHByRUZh"
                      target="_blank"
                      >找我婚礼退单标准说明</a
                    >
                    <i class="el-icon-arrow-right" />
                  </div>
                </el-option>
              </el-select>
            </template>
          </div>
          <div class="top-right">
            <div class="app-code-section flex-row">
              <img
                src="../../assets/images/phone.png"
                width="11"
                alt="phone"
                class="phone-icon"
              />
              <div class="down-app-text">下载APP</div>
              <div class="app-sub-content">
                <img
                  src="../../assets/images/logo-img.png"
                  width="54"
                  alt="logo"
                />
                <p class="app-main-title">找我婚礼APP</p>
                <p class="app-sub-title">让每一场婚礼都超越期待</p>
                <img
                  src="https://img.izhaowo.com/pc-wap/image/new-down-app.png"
                  width="92"
                  alt="code"
                />
              </div>
            </div>
            <!-- 登录 -->
            <div class="f-login">
              <div class="f-login-c" v-if="!isLogin">
                <a
                  id="tj-header-login"
                  :href="newUrl + '/login'"
                  class="cup"
                  style="margin: 0 10px"
                  rel="nofollow"
                  >登录</a
                >
              </div>
              <div class="f-login-c" v-else>
                <a :href="userUrl + '/collect/team.html'" target="_blank">
                  <img v-if="imgsrc" :src="imgsrc | imgcrop(30, 30)" />
                  <img src="../../assets/images/default-peo.png" v-else />
                  <span class="user-name">{{ userName }}</span>
                </a>
                <a class="cup" @click="clearCookie">退出</a>
              </div>
            </div>
            <!-- 招募合伙人 -->
            <!-- <a
              :href="newUrl + '/cityPartner'"
              tag="a"
              class="go-partner"
              target="_blank"
              >招募城市合伙人</a
            > -->
            <a href="https://w.izhaowo.com" class="go-worker" target="_blank"
              >婚礼人入驻</a
            >
          </div>
        </div>
      </div>
      <!-- 顶部菜单栏 -->
      <div class="wrapper">
        <div class="flex-row page-width-header" style="align-items: center">
          <a :href="newUrl" tag="div" class="logo"></a>
          <div class="menu-item" :class="{ selected: isIndex }">
            <a :href="newUrl" class="link">首页</a>
          </div>
          <div
            class="menu-item"
            :class="{ selected: menu.selected }"
            v-for="menu in menuList"
            :key="menu.name"
          >
            <a :href="newUrl + menu.path" class="link">{{ menu.name }}</a>
            <div class="menu-second" v-show="menu.name === '婚礼团队'">
              <a :href="newUrl + '/worker/b0'">策划师</a>
              <a :href="newUrl + '/worker/b1'">化妆师</a>
              <a :href="newUrl + '/worker/b2'">主持人</a>
              <a :href="newUrl + '/worker/b3'">摄影师</a>
              <a :href="newUrl + '/worker/b4'">摄像师</a>
              <a :href="newUrl + '/planner'">统筹师</a>
            </div>
            <div class="menu-second" v-show="menu.name === '服务介绍'">
              <a :href="newUrl + '/goods'">服务流程</a>
              <a :href="newUrl + '/planner'">统筹服务</a>
            </div>
            <div class="menu-second"></div>
          </div>

          <i style="flex-grow: 1"></i>
          <!-- 搜索 -->
          <div class="search-box">
            <el-input
              placeholder="请输入关键词"
              v-model="searchBarText"
              @keyup.native.enter="searchHeader"
              class="search-input-select"
            >
              <el-select
                v-model="searchBar"
                placeholder="请选择"
                slot="prepend"
              >
                <el-option
                  v-for="item in searchBarOptions"
                  :key="item.value"
                  :label="item.label"
                  v-show="item.value != searchBar"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchHeader"
                style="background-color: #50d3da"
              ></el-button>
            </el-input>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import CookieUtil from "@/plugin/cookie.js";
import api from "@/config/api.js";
export default {
  name: "base-barner",
  data() {
    return {
      userUrl: "https://my.izhaowo.com",
      newUrl: api.WWW_IZHAOWO_URL,
      headerLogo: false,
      // 页面是否刷新
      relouded: false,
      isIndex: false,
      menuList: [
        { selected: false, name: "婚礼案例", path: "/case" },
        { selected: false, name: "婚礼团队", path: "/worker/b0" },
        { selected: false, name: "婚宴酒店", path: "/hotel" },
        { selected: false, name: "婚车预定", path: "/car" },
        { selected: false, name: "婚礼攻略", path: "/knowledge" },
        // { selected: false, name: '服务介绍', path: '/goods' }
      ],
      searchBar: "婚礼人",
      searchBarOptions: [
        {
          value: "婚礼人",
          label: "婚礼人",
        },
        {
          value: "酒店",
          label: "酒店",
        },
        {
          value: "案例",
          label: "案例",
        },
      ],
      regionBar: "",
      regionBarOptions: [],
      searchBarText: "",
      isLogin: "",
      imgsrc: "",
      userName: "",
      provinceUrl: "",
    };
  },
  created() {
    this.isLogin = CookieUtil.get("usr-token") ? true : false;
    this.imgsrc = CookieUtil.get("usr-avator")
      ? CookieUtil.get("usr-avator")
      : "";
    this.userName = CookieUtil.get("usr-name")
      ? CookieUtil.get("usr-name")
      : "";
    this.init();
  },

  methods: {
    async init() {
      await this.queryProvince();
      console.log(CookieUtil.get("PROVINCE_NAME"));
      this.regionBar = CookieUtil.get("PROVINCE_NAME") || "";
      // let list = CookieUtil.get('PROVINCE_LIST')
      // if(list == 'undefined' || !list || list.length <= 0){
      //   console.log('test')
      //   await this.queryProvince()
      // }else{
      //   let data = list.split(",")
      //   this.$set(this,'regionBarOptions',list)
      // }
    },
    async queryProvince() {
      let result = [];
      let list = [];
      let url = api.TOP_URL + "app-api/province/v1/query/list";
      let all_city = [];
      let vm = this;
      vm.getAjax(
        url,
        "",
        function (recomData) {
          if (recomData && recomData.rcode === "000000") {
            result = recomData.rdata;
            for (let i in result) {
              let item = {};
              item.value = result[i].province;
              item.label = result[i].province;
              item.province_id = result[i].provinceId;
              item.provincialCapitalEn = "/" + result[i].provincialCapitalEn;
              item.index = parseInt(i) + 1;
              item.citys = result[i].citys;
              if (
                result[i].province === "重庆市" ||
                result[i].province === "天津市" ||
                result[i].province === "上海市" ||
                result[i].province === "北京市"
              ) {
                item.citys.push({
                  name: result[i].province,
                });
              }
              list.push(item);
              //全国显示所有城市
              all_city.push(...result[i].citys);
            }
            //省份中没有返回全国字段 需要自己拼接
            list.unshift({
              value: "",
              label: "全国",
              province_id: "",
              index: 0,
              provincialCapitalEn: "/",
              citys: all_city,
              province: "全国",
            });
            if (result && result.length > 0) {
              //设置省份配置地址
              CookieUtil.set("PROVINCE_LIST", list);
              vm.$set(vm, "regionBarOptions", list);
            }
          }
        },
        function () {}
      );
    },
    /**
     * 退出登录
     */
    clearCookie: function () {
      //清楚cookie
      CookieUtil.delete("usr-token");
      CookieUtil.delete("usr-token", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-name");
      CookieUtil.delete("usr-name", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-avator");
      CookieUtil.delete("usr-avator", { domain: ".izhaowo.com" });
      CookieUtil.delete("usr-id");
      CookieUtil.delete("usr-id", { domain: ".izhaowo.com" });
      CookieUtil.delete("wed-info");
      CookieUtil.delete("wed-date");
      window.location.reload(true);
      return;
    },

    /**
     * 头部搜索
     */
    searchHeader() {
      if (this.searchBar === "婚礼人") {
        window.location.href = this.newUrl + `/worker?s=${this.searchBarText}`;
      } else if (this.searchBar === "酒店") {
        window.location.href = this.newUrl + `/hotel?s=${this.searchBarText}`;
      } else if (this.searchBar === "案例") {
        window.location.href = this.newUrl + `/case?s=${this.searchBarText}`;
      } else if (this.searchBar === "攻略") {
        window.location.href =
          this.newUrl + `/strategy?s=${this.searchBarText}`;
      }
    },

    // 改变省份时触发
    change_province(value) {
      for (let [index, item] of this.regionBarOptions.entries()) {
        if (item.value === value) {
          CookieUtil.set("PROVINCE_ID", item.province_id);
          CookieUtil.set("PROVINCE_INDEX", item.index);
          CookieUtil.set("PROVINCE_NAME", item.value);
        }
      }
    },
  },

  mounted() {
    this.isLogin = !!CookieUtil.get("usr-token");
    this.imgsrc = CookieUtil.get("usr-avator")
      ? CookieUtil.get("usr-avator")
      : "";
  },
};
</script>

<style scoped>
.fixed-position {
  position: relative;
  min-height: 120px;
}
.head-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  min-width: 1200px;
  width: 100vw;
  font-size: 14px !important;
  min-height: 120px;
  background: #ffffff;
  border-bottom: 1px solid #f3f3f3;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head-bar .wrapper {
  min-height: 80px;
}
.head-bar .logo {
  margin-right: 30px;
  width: 128px;
  height: 44px;
  background: url(https://img.izhaowo.com/pc-wap/image/logo-v2.png) 0 0
    no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}

.head-bar .icon-logo {
  width: 112px;
}

.head-bar .menu-item > a {
  cursor: pointer !important;
  margin: 0 20px;
  font-size: 16px;
  color: #000000;
  line-height: 50px !important;
  height: 50px;
  display: block;
}
.menuLink {
  font-size: 16px;
  color: #000000;
  line-height: 50px;
  height: 50px;
  margin-left: 20px;
}
.menuLink::hover {
  border-bottom: 2px solid #00d5ce;
}
.menu-item.selected .link {
  color: #00d5ce;
  border-bottom: 2px solid #00d5ce !important;
}
.menu-item:hover .link {
  border-bottom: 2px solid #00d5ce;
}

.login {
  margin-left: 20px;
}
/* 下面菜单 */
.head-bar .head-top {
  width: 100%;
  height: 40px;
  background: #f9f9f9;
}
.head-top .top-container {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 1200px;
}
.top-left,
.top-right {
  display: flex;
  align-items: center;
}
.menu-item {
  position: relative;
}
.menu-item .menu-second {
  display: none;
  width: 100%;
  position: absolute;
  top: 50px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}
.menu-second a {
  display: block !important;
  height: 40px;
  line-height: 40px !important;
  width: 100%;
  border-bottom: 0;
  text-align: center !important;
}
.menu-second a:hover {
  color: #00d5ce;
}
.menu-item:hover .menu-second {
  display: block;
}
.app-code-section {
  position: relative;
  align-items: center;
  margin-right: 40px;
}
.app-code-section img.phone-icon {
  vertical-align: middle;
  font-size: 0;
}
.app-code-section .down-app-text {
  margin-left: 5px;
  color: #a28b77 !important;
  font-size: 12px !important;
  font-weight: 550 !important;
}
.app-code-section:hover .app-sub-content {
  display: block;
}
.app-code-section .app-sub-content {
  display: none;
  position: absolute;
  left: -50px;
  top: 32px;
  z-index: 999;
  padding: 34px 0 32px;
  width: 176px;
  height: 295px;
  background: #ffffff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  color: #333;
}
.app-sub-content .app-main-title {
  margin-top: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
}
.app-sub-content .app-sub-title {
  margin: 4px 0 32px;
  font-family: PingFangSC-Light;
  color: #555;
  font-size: 12px;
}
.app-sub-content::before {
  content: "";
  position: absolute;
  left: calc(50% - 7px);
  top: -10px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid #ffffff;
}
.f-login .f-login-c {
  display: flex;
  align-items: center;
  color: #464646;
  font-size: 12px;
}
.f-login-c a {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 12px;
}
.f-login img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: baseline;
}
.f-login .user-name {
  margin: 0 10px;
  font-size: 12px;
}
.go-partner,
.go-worker {
  margin-left: 40px;
  font-size: 12px;
}
.page-width-header {
  min-width: 1200px;
  min-height: 80px;
}
</style>

<style>
/* 区域选择 */
.regionSelect {
  width: 80px;
  border: none;
}
.regionSelect.fee-select {
  margin-left: 20px;
  width: 140px;
}
.fee-select-popper {
  width: 256px;
}
.fee-select-popper .fee-select-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  color: #464646;
}
.fee-select-item a {
  height: 100%;
  line-height: 34px;
  font-size: 12px !important;
}
.fee-select .el-input__inner::placeholder {
  color: #333;
}
.regionSelect .el-input__inner {
  border: none !important;
  background: none;
  font-size: 12px !important;
}

.searchBarSelect .el-icon-arrow-up:before,
.regionSelect .el-icon-arrow-up:before {
  content: "\e6e1";
  color: #666;
}

.search-box .el-select .el-input {
  width: 86px !important;
}
.search-input-select .el-input-group__prepend {
  background-color: #fff !important;
  border-right: 0 !important;
  border-color: #f1f1f1 !important;
}
.search-input-select input[type="text"] {
  border-top-color: #f1f1f1 !important;
  border-bottom-color: #f1f1f1 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}
.search-input-select . {
  background-color: #a28b77 !important;
  border-radius: 0 4px 4px 0 !important;
}
.search-input-select .el-input-group__append .el-icon-search {
  color: #fff !important;
  font-size: 18px !important;
}
/* / header 透明 */
</style>



// WEBPACK FOOTER //
// top-bar.vue?54fdeeb0